import React from 'react'
import { Col } from 'react-bootstrap'
import { getFrequenciesBasedOnAdminConfig, productDeps } from 'src/deps'
import { customerContainer } from 'src/models'
import {
  i18nTranslate,
  IS_BROWSER,
  trackV2SubscriptionButtonClick,
} from 'src/utils'
import { APPConfig } from 'config/appConfig'
import { productState } from '../../BaseProductComponent'
import FrequencyDropdownV2 from '../../FrequencyDropdownV2'
import TickIcon from '../../Icons/TickIcon'
import './styles.scss'

class SubscriptionFrequency extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.frequencyButtonRefs = {}
    const isToEnableOneTimeFrequency =
      APPConfig?.getAppConfig()?.oneTimeFrequencyEnabled === 'true'
    let {
      frequencyPeriod = 1,
      frequencyType = 'Every month',
      orderType = 'VARIABLE_MULTI_ORDER',
      isFromPDP = false,
      isToHideMonthlyFrequency = false,
      isMonthlyLabel = false,
    } = this.props
    const frequencyValue = `${frequencyPeriod}-${frequencyType}`
    let frequenciesBasedOnAdminConfig = getFrequenciesBasedOnAdminConfig({
      isFromPDP,
      isToHideMonthlyFrequency,
      isMonthlyLabel,
    })
    let value = frequenciesBasedOnAdminConfig[0]?.value
    let label = frequenciesBasedOnAdminConfig[0]?.label
    let isOneTime = false
    if (!isToEnableOneTimeFrequency) {
      frequenciesBasedOnAdminConfig = frequenciesBasedOnAdminConfig?.filter(
        item => {
          return !(item?.isOneTime === true)
        }
      )
      value = frequenciesBasedOnAdminConfig[0].value
      label = frequenciesBasedOnAdminConfig[0].label
    }
    const subscriptionVal = frequenciesBasedOnAdminConfig.filter(
      item => frequencyValue == item.value
    )

    if (subscriptionVal.length) {
      if (subscriptionVal.length === 1) {
        value = subscriptionVal[0].value
        label = subscriptionVal[0].label
      } else {
        if (orderType === 'VARIABLE_SINGLE_ORDER') {
          value = subscriptionVal[1].value
          label = subscriptionVal[1].label
          isOneTime = subscriptionVal?.[1]?.isOneTime || false
        } else {
          value = subscriptionVal[0].value
          label = subscriptionVal[0].label
        }
      }
    }
    this.state = {
      selectedFrequency: '1-MONTHS',
      selectedValue: value,
      selectedLabel: label,
      focusedValue: value,
      frequenciesBasedOnAdminConfig,
    }
  }

  /**
   * Handles the click event for each frequency button.
   * Updates the component's state with the new selected frequency.
   * @param {string} frequency - The string representing the selected frequency ('monthly', 'every_2_months', 'every_3_months').
   */
  handleSelection = frequency => {
    this.setState({ selectedFrequency: frequency })
  }

  getAccountType = () => {
    if (IS_BROWSER) {
      return customerContainer.profileResponse?.accounts?.type || ''
    }
    return this?.context?.customerType
  }

  isBAorPreferred = () => {
    const accountType = this.getAccountType()
    return (
      accountType === 'Brand Affiliate' ||
      accountType === 'Brand Affiliate - Business Entity' ||
      accountType === 'Preferred Customer/Member' ||
      false
    )
  }

  handlePDPSubscriptionFrequency = value => {
    const { frequenciesBasedOnAdminConfig } = this.state
    const [frequencyPeriod, frequencyType] = value?.split?.('-')
    productState.selectedFrequencyValueInPDP = {
      frequencyPeriod,
      frequencyType,
    }
    const label = frequenciesBasedOnAdminConfig.find(
      item => item.value === value
    )?.label
    this.setState({
      selectedValue: value,
      selectedLabel: label,
      focusedValue: value,
    })
    this.props.handleSubProductSubscribeSelect &&
      this.props.handleSubProductSubscribeSelect(false, false, value)
  }

  handleDesktopFrequencyKeyDown = (e, frequencies, currentIndex, frequency) => {
    if (e.key === 'Tab') {
      const isShiftTab = e.shiftKey
      const isFirstOption = currentIndex === 0
      const isLastOption = currentIndex === frequencies.length - 1

      // Avoid keyboard trap: only intercept Tab while navigating inside list bounds.
      if ((isShiftTab && isFirstOption) || (!isShiftTab && isLastOption)) {
        return
      }

      e.preventDefault()
      const nextIndex = isShiftTab ? currentIndex - 1 : currentIndex + 1
      const nextValue = frequencies[nextIndex]?.value
      this.setState({ focusedValue: nextValue }, () => {
        this.frequencyButtonRefs[nextValue]?.focus()
      })
      return
    }

    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault()
      this.handlePDPSubscriptionFrequency(frequency.value)
    }
  }

  getTotalPriceFromTotalValueNode = value => {
    // we are manually selecting the total based on price option selected
    // here only one promotion call made
    const priceFacets = value?.priceFacets || {}
    const priceFacetPattern = customerContainer?.isToShowMemberPrice(
      priceFacets
    )
      ? 'Member'
      : 'Wholesale'
    let totalValue = ''
    if (productState.currentlySelectedPriceOption === 'one-time-price-button') {
      if (this.isBAorPreferred()) {
        const isZeroPriceAfterDiscount =
          priceFacets?.[`${priceFacetPattern} Price`]?.[
            `${priceFacetPattern} PriceAfterDiscount`
          ] === 0
        totalValue = isZeroPriceAfterDiscount
          ? 0
          : priceFacets?.[`${priceFacetPattern} Price`]?.[
              `${priceFacetPattern} PriceAfterDiscount`
            ] ||
            priceFacets?.[`${priceFacetPattern} Price`]?.[
              `${priceFacetPattern} Price`
            ]
      } else {
        const isZeroPriceAfterDiscount =
          priceFacets?.['Regular Price']?.['Regular PriceAfterDiscount'] === 0
        totalValue = isZeroPriceAfterDiscount
          ? 0
          : priceFacets?.['Regular Price']?.['Regular PriceAfterDiscount'] ||
            priceFacets?.['Regular Price']?.['Regular Price']
      }
    } else {
      if (this.isBAorPreferred()) {
        const isZeroPriceAfterDiscount =
          priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
            `Sub ${priceFacetPattern} PriceAfterDiscount`
          ] === 0
        totalValue = isZeroPriceAfterDiscount
          ? 0
          : priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
              `Sub ${priceFacetPattern} PriceAfterDiscount`
            ] ||
            priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
              `Sub ${priceFacetPattern} Price`
            ]
      } else {
        const isZeroPriceAfterDiscount =
          priceFacets?.['Sub Retail Price']?.[
            'Sub Retail PriceAfterDiscount'
          ] === 0
        totalValue = isZeroPriceAfterDiscount
          ? 0
          : priceFacets?.['Sub Retail Price']?.[
              'Sub Retail PriceAfterDiscount'
            ] || priceFacets?.['Sub Retail Price']?.['Sub Retail Price']
      }
    }
    return totalValue
  }

  getTotalDiscountFromTotalValueNode = value => {
    const priceFacets = value?.priceFacets || {}
    const priceFacetPattern = customerContainer?.isToShowMemberPrice(
      priceFacets
    )
      ? 'Member'
      : 'Wholesale'
    let totalDiscount = ''
    if (productState.currentlySelectedPriceOption === 'one-time-price-button') {
      if (this.isBAorPreferred()) {
        totalDiscount =
          priceFacets?.[`${priceFacetPattern} Price`]?.[
            `${priceFacetPattern} PriceDiscount`
          ] || 0
      } else {
        totalDiscount =
          priceFacets?.['Regular Price']?.['Regular PriceDiscount'] || 0
      }
    } else {
      if (this.isBAorPreferred()) {
        totalDiscount =
          priceFacets?.[`Sub ${priceFacetPattern} Price`]?.[
            `Sub ${priceFacetPattern} PriceDiscount`
          ] || 0
      } else {
        totalDiscount =
          priceFacets?.['Sub Retail Price']?.['Sub Retail PriceDiscount'] || 0
      }
    }
    return totalDiscount
  }

  trackSubscriptionFrequencyView = () => {
    const frequencyPeriod =
      productState.selectedFrequencyValueInPDP?.frequencyPeriod || ''
    const frequencyType =
      productState.selectedFrequencyValueInPDP?.frequencyType || ''
    const totalValueNode = productDeps.getTotalValueNode(this.props)
    const totalValue = this.getTotalPriceFromTotalValueNode(totalValueNode)
    const totalDiscount =
      this.getTotalDiscountFromTotalValueNode(totalValueNode)

    const linkText = i18nTranslate('pdp.subscribesave', 'Subscribe & save', {
      nameSpace: 'ssr-resource',
    })
    const linkUrl = window.location.pathname
    trackV2SubscriptionButtonClick({
      event: 'subscription_detail_item',
      item_id: this.props?.product?.skuId || '',
      item_name: this.props?.product?.properties?.name || '',
      item_discount: totalDiscount,
      item_total: totalValue || 0,
      item_quantity: this.props.productCount || '1',
      item_frequency: frequencyPeriod + ' ' + frequencyType,
      link_text: linkText,
      link_url: linkUrl,
      processing_day: '',
    })
  }

  resetAndTrackFrequencyView = () => {
    productState.resetFrequencyStateInPDP()
    this.trackSubscriptionFrequencyView()
  }

  renderMobileFrequencyDropdown = () => {
    const { isFromPDP = false, isMonthlyLabel = false } = this.props
    return (
      <Col
        lg={6}
        sm={12}
        xs={12}
        className="subscription-frequency-dropdown-new pl-0">
        <FrequencyDropdownV2
          isFromPDP={isFromPDP}
          enabledNewPdp={true}
          isMonthlyLabel={isMonthlyLabel}
          selectedFrequencyLabel={this.state.selectedLabel}
          handleSubscriptionFrequency={this.handlePDPSubscriptionFrequency}
          handleFrequencyDidMount={this.resetAndTrackFrequencyView}
          handleFrequencyUnmount={productState.resetFrequencyStateInPDP}
        />
      </Col>
    )
  }

  renderDesktopViewFrequency = () => {
    const { selectedValue, focusedValue, frequenciesBasedOnAdminConfig } =
      this.state
    const isSelected = frequency => selectedValue === frequency
    const selectedLabel = frequenciesBasedOnAdminConfig.find(
      item => item.value === selectedValue
    )?.label
    return (
      <div>
        <div
          className="desktop-view-container"
          role="group"
          aria-label={i18nTranslate(
            'subscriptions.frequency_selection_aria_label',
            'Subscription Frequency Selection',
            { nameSpace: 'ssr-resource' }
          )}>
          <div
            role="status"
            aria-live="polite"
            aria-atomic="true"
            className="sr-only"
            data-testid="qa-frequency-selection-announcement">
            {selectedLabel &&
              i18nTranslate(
                'subscriptions.frequency_changed',
                `Frequency changed to `,
                { nameSpace: 'ssr-resource' }
              ) + selectedLabel}
          </div>
          {frequenciesBasedOnAdminConfig.map((freq, index) => (
            <button
              key={freq.value}
              type="button"
              ref={element => {
                this.frequencyButtonRefs[freq.value] = element
              }}
              onClick={() => this.handlePDPSubscriptionFrequency(freq.value)}
              onKeyDown={e =>
                this.handleDesktopFrequencyKeyDown(
                  e,
                  frequenciesBasedOnAdminConfig,
                  index,
                  freq
                )
              }
              className={`
                  ${
                    isSelected(freq.value)
                      ? 'selected-frequency-btn'
                      : 'unselected-frequency-btn'
                  }
                `}
              data-testid={`frequency-button-${freq.value}`}
              aria-pressed={isSelected(freq.value)}
              aria-label={`${freq.label}${isSelected(freq.value) ? ', selected' : ''}`}
              aria-live={isSelected(freq.value) ? 'polite' : undefined}
              tabIndex={isSelected(freq.value) ? 0 : -1}>
              <div>
                {isSelected(freq.value) && (
                  <TickIcon
                    className="absolute tick-icon"
                    height="16"
                    width="16"
                    aria-hidden="true"
                  />
                )}
              </div>
              <p
                className={`${isSelected(freq.value) ? 'selected-frequency-btn-label' : ''}`}>
                {freq.label}
              </p>
            </button>
          ))}
        </div>
      </div>
    )
  }

  render() {
    const { selectedLabel } = this.state
    return (
      <div
        className="subs-frequency-container"
        role="region"
        aria-label={i18nTranslate(
          'subscriptions.frequency_selection_region_aria_label',
          'Subscription frequency selection',
          { nameSpace: 'ssr-resource' }
        )}>
        <p
          className="selected-frequency-text"
          data-testid="qa-selected-frequency"
          aria-live="polite">
          {i18nTranslate('pdp.selectFrequency', 'Select Frequency:')}{' '}
          <span
            aria-label={`${i18nTranslate('pdp.currently_selected', 'Currently selected', { nameSpace: 'ssr-resource' })} : ${selectedLabel}`}>
            {selectedLabel}
          </span>
        </p>

        <div className="d-none d-md-block" data-testid="qa-desktop-frequency">
          {this.renderDesktopViewFrequency()}
        </div>
        <div className="d-block d-md-none" data-testid="qa-mobile-frequency">
          {this.renderMobileFrequencyDropdown()}
        </div>
      </div>
    )
  }
}

export default SubscriptionFrequency
